module.exports = __webpack_public_path__ + "static/media/fm-diamond-bullet.2951585f.svg";